export const comments_3253778 = {"data":{"data":[],"links":{}}}